import styled from 'styled-components';
import tw from 'tailwind.macro';
import ImageTestimonial from '../../../../images/travelers/customers.png';

const Container = styled.div`
  ${tw`relative`}
`;

const Image = styled.img`
  ${tw`w-full`}
  max-height: 430px;
  object-fit: contain;
`;

const CustomerImages = () => (
  <Container>
    <Image alt="Testimonial pictures" src={ImageTestimonial} />
  </Container>
);

export default CustomerImages;
